module.exports = __webpack_public_path__ + "static/media/siD_app_icon.369ca6aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/siD_app_icon.svg
// module id = 741
// module chunks = 21